import ComingSoon from "../../components/shared/ComingSoon";

export default function ProjectYou() {
  return (
    <div className="text-white md:px-0 px-4">
      <ComingSoon />
    </div>
  );
}